import React, { useEffect, useState } from "react";
import VisibilityOutlinedIcon from "@mui/icons-material/VisibilityOutlined";
import TaskAltOutlinedIcon from "@mui/icons-material/TaskAltOutlined";
import RestartAltIcon from "@mui/icons-material/RestartAlt";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import FiltroMultiple from "../../../Postventa/Dashboard/Modales/FiltroMultiple";
import { soloFecha } from "./datosVisitas";

const ESTADO_VACIO_FILTROS = { cliente: [], asesor: [], tipoVisita: [], linea: [], estatus: [] };
const ESTADO_VACIO_MOSTRAR = { cliente: { open: false }, asesor: { open: false }, tipoVisita: { open: false }, linea: { open: false }, estatus: { open: false } };

// Vista de listado en tabla — datos reales (VisitasCRM/ListadoVisitasProgramadas).
// El renglón abre el detalle de la visita; las acciones (estatus/ver/eliminar) usan stopPropagation.
// Filtros por columna (Asesor/Tipo de visita/Estatus) — mismo patrón que CotizacionesTablaScreen.
export const VisitasListado = ({ filas, onOpenDetalle, onOpenEstatus, onEliminar, ocultarAsesor = false, puedeRevertir = false, onRevertirEstatus }) => {
  const [options, setOptions] = useState(ESTADO_VACIO_FILTROS);
  const [filtros, setFiltros] = useState(ESTADO_VACIO_FILTROS);
  const [filtrosTemp, setFiltrosTemp] = useState(ESTADO_VACIO_FILTROS);
  const [mostrarFiltro, setMostrarFiltro] = useState(ESTADO_VACIO_MOSTRAR);
  const [prioridadFiltros, setPrioridadFiltros] = useState([]);
  const [datosFiltrados, setDatosFiltrados] = useState([]);

  const actualizarPrioridad = (filtro) => {
    setPrioridadFiltros((prev) => {
      const index = prev.indexOf(filtro);
      const nuevasPrioridades = index === -1 ? [...prev, filtro] : prev.slice(0, index + 1);

      setFiltrosTemp((prevTemp) => {
        const limpio = { ...prevTemp };
        Object.keys(limpio).forEach((key) => {
          if (!nuevasPrioridades.includes(key)) limpio[key] = [];
        });
        return limpio;
      });

      setFiltros((prevFiltros) => {
        const limpio = { ...prevFiltros };
        Object.keys(limpio).forEach((key) => {
          if (!nuevasPrioridades.includes(key)) limpio[key] = [];
        });
        return limpio;
      });

      return nuevasPrioridades;
    });
  };

  // Opciones únicas por columna — se recalculan cada vez que cambian las filas recibidas
  useEffect(() => {
    setOptions({
      cliente: [...new Set(filas.map((v) => v.razon_social).filter(Boolean))].map((v) => ({ value: v, label: v })),
      asesor: [...new Set(filas.map((v) => v.vendedor).filter(Boolean))].map((v) => ({ value: v, label: v })),
      tipoVisita: [...new Set(filas.map((v) => v.visita).filter(Boolean))].map((v) => ({ value: v, label: v })),
      linea: [...new Set(filas.map((v) => v.linea).filter(Boolean))].map((v) => ({ value: v, label: v })),
      estatus: [...new Set(filas.map((v) => v.estatus_texto).filter(Boolean))].map((v) => ({ value: v, label: v })),
    });
  }, [filas]);

  // Aplica los filtros activos (en orden de prioridad) sobre las filas recibidas
  useEffect(() => {
    let data = [...filas];

    prioridadFiltros.forEach((filtro) => {
      if (filtro === "cliente" && filtros.cliente.length > 0) {
        data = data.filter((v) => filtros.cliente.includes(v.razon_social));
      }
      if (filtro === "asesor" && filtros.asesor.length > 0) {
        data = data.filter((v) => filtros.asesor.includes(v.vendedor));
      }
      if (filtro === "tipoVisita" && filtros.tipoVisita.length > 0) {
        data = data.filter((v) => filtros.tipoVisita.includes(v.visita));
      }
      if (filtro === "linea" && filtros.linea.length > 0) {
        data = data.filter((v) => filtros.linea.includes(v.linea));
      }
      if (filtro === "estatus" && filtros.estatus.length > 0) {
        data = data.filter((v) => filtros.estatus.includes(v.estatus_texto));
      }
    });

    setDatosFiltrados(data);
  }, [filas, filtros, prioridadFiltros]);

  const filasVisibles = datosFiltrados;

  return (
    <div className="vp-listado">
      <div className="vp-tabla-scroll scroll">
      <table className="vp-tabla">
        <thead>
          <tr>
            <th className="vp-th-sticky-left">
              <div className="borde-izq">
                <FiltroMultiple
                  label="Cliente"
                  field="cliente"
                  options={options.cliente}
                  filtros={filtros}
                  setFiltros={setFiltros}
                  filtrosTemp={filtrosTemp}
                  setFiltrosTemp={setFiltrosTemp}
                  mostrarFiltro={mostrarFiltro}
                  setMostrarFiltro={setMostrarFiltro}
                  actualizarPrioridad={actualizarPrioridad}
                  setPrioridadFiltros={setPrioridadFiltros}
                />
              </div>
            </th>
            {!ocultarAsesor && (
              <th>
                <div className="borde-izq">
                  <FiltroMultiple
                    label="Asesor"
                    field="asesor"
                    options={options.asesor}
                    filtros={filtros}
                    setFiltros={setFiltros}
                    filtrosTemp={filtrosTemp}
                    setFiltrosTemp={setFiltrosTemp}
                    mostrarFiltro={mostrarFiltro}
                    setMostrarFiltro={setMostrarFiltro}
                    actualizarPrioridad={actualizarPrioridad}
                    setPrioridadFiltros={setPrioridadFiltros}
                  />
                </div>
              </th>
            )}
            <th className="vp-th-centro">Fecha de creación</th>
            <th className="vp-th-centro">Fecha de visita</th>
            <th className="vp-th-centro">
              <div className="borde-izq">
                <FiltroMultiple
                  label="Tipo de visita"
                  field="tipoVisita"
                  options={options.tipoVisita}
                  filtros={filtros}
                  setFiltros={setFiltros}
                  filtrosTemp={filtrosTemp}
                  setFiltrosTemp={setFiltrosTemp}
                  mostrarFiltro={mostrarFiltro}
                  setMostrarFiltro={setMostrarFiltro}
                  actualizarPrioridad={actualizarPrioridad}
                  setPrioridadFiltros={setPrioridadFiltros}
                />
              </div>
            </th>
            <th>
              <div className="borde-izq">
                <FiltroMultiple
                  label="Línea"
                  field="linea"
                  options={options.linea}
                  filtros={filtros}
                  setFiltros={setFiltros}
                  filtrosTemp={filtrosTemp}
                  setFiltrosTemp={setFiltrosTemp}
                  mostrarFiltro={mostrarFiltro}
                  setMostrarFiltro={setMostrarFiltro}
                  actualizarPrioridad={actualizarPrioridad}
                  setPrioridadFiltros={setPrioridadFiltros}
                />
              </div>
            </th>
            <th>
              <div className="borde-izq">
                <FiltroMultiple
                  label="Estatus"
                  field="estatus"
                  options={options.estatus}
                  filtros={filtros}
                  setFiltros={setFiltros}
                  filtrosTemp={filtrosTemp}
                  setFiltrosTemp={setFiltrosTemp}
                  mostrarFiltro={mostrarFiltro}
                  setMostrarFiltro={setMostrarFiltro}
                  actualizarPrioridad={actualizarPrioridad}
                  setPrioridadFiltros={setPrioridadFiltros}
                />
              </div>
            </th>
            <th>Comentarios</th>
            <th className="vp-th-centro vp-th-sticky-right">Acciones</th>
          </tr>
        </thead>
        <tbody>
          {filasVisibles.map((v) => {
            const esRealizada = v.estatus === "R";
            const esVencida = v.estatus === "V";
            const esPendiente = v.estatus === "P";
            return (
              <tr key={v.id_visita}>
                <td className="vp-td-cliente vp-td-sticky-left">{v.razon_social}</td>
                {!ocultarAsesor && <td>{v.vendedor}</td>}
                <td className="vp-td-centro">{soloFecha(v.createdate)}</td>
                <td className="vp-td-fecha vp-td-centro">{soloFecha(v.fecha_visita)}</td>
                <td className="vp-td-centro">{v.visita}</td>
                <td className="vp-td-centro">{v.linea || "—"}</td>
                <td>
                  <span
                    className="vp-estatus-pill"
                    style={{ background: v.estatusEstilo.bg, color: v.estatusEstilo.fg }}
                  >
                    {v.estatus_texto}
                  </span>
                </td>
                <td className="vp-td-comentarios">{v.comentario || "—"}</td>
                <td className="vp-td-centro vp-td-sticky-right">
                  <div className="vp-acciones">
                    {esRealizada && puedeRevertir ? (
                      <button
                        type="button"
                        className="vp-btn-accion"
                        title="Revertir a pendiente"
                        onClick={(e) => { e.stopPropagation(); onRevertirEstatus(v); }}
                      >
                        <RestartAltIcon fontSize="small" />
                      </button>
                    ) : (
                      <button
                        type="button"
                        className="vp-btn-accion"
                        title={esRealizada ? "Visita ya realizada" : esVencida ? "Visita vencida, no se puede marcar como realizada" : "Marcar como realizada"}
                        disabled={esRealizada || esVencida}
                        onClick={(e) => { e.stopPropagation(); onOpenEstatus(v); }}
                      >
                        <TaskAltOutlinedIcon fontSize="small" />
                      </button>
                    )}
                    <button
                      type="button"
                      className="vp-btn-accion"
                      title="Visualizar"
                      onClick={(e) => { e.stopPropagation(); onOpenDetalle(v); }}
                    >
                      <VisibilityOutlinedIcon fontSize="small" />
                    </button>
                    <button
                      type="button"
                      className="vp-btn-accion vp-btn-accion-eliminar"
                      title={esPendiente ? "Eliminar" : "Solo se pueden eliminar visitas pendientes"}
                      disabled={!esPendiente}
                      onClick={(e) => { e.stopPropagation(); onEliminar(v); }}
                    >
                      <DeleteOutlineIcon fontSize="small" />
                    </button>
                  </div>
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
      </div>
      <div className="vp-tabla-total">Total · {filasVisibles.length} visitas</div>
    </div>
  );
};
